import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Router, Switch, Route, Redirect
} from 'react-router';
import { Title } from 'components/Title/Title';
import env from 'config/environment';
import { rootSelectors } from '@redux/modules/selectors';
import {
  fetchEnvironmentRequest,
  fetchStatusRequest,
} from '@redux/modules/api/actions';
import App from 'components/Main/App';
import { LandingPage } from '../../views/LandingPage';
import { HelpVideo } from '../../views/HelpVideo';
import { Login } from '../../views/Login';
import { VerificationPage } from '../../views/VerificationPage';
import {
  Loading,
  AccessDenied,
  Locked,
  ErrorView,
  DuplicateSession,
  TokenRefresh,
  Help,
  Instructions,
  NotFound,
} from '../../views';
import ProtectedRoute from '../ProtectedRoute';

class Main extends React.Component {
  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate() {
    this.initialize();
  }

  initialize = () => {
    if (!this.props.hasFetchResponses.status) {
      this.props.dispatch(fetchStatusRequest());
    }
    if (!this.props.hasFetchResponses.environment) {
      this.props.dispatch(fetchEnvironmentRequest());
    }
  };

  render() {
    return (
      <>
        <Loading show={this.props.isLoading} />

        <Router history={env.History()}>
          <Switch>
            <ProtectedRoute exact path="/verification" component={VerificationPage} />
            <ProtectedRoute exact path="/landingpage" component={LandingPage} />
            <Route exact path="/login" component={Login} />
            <Route
              exact
              path="/form"
              render={() => (<Redirect to="/login" />)}
            />
            <ProtectedRoute exact path="/form/:section/:subsection*" component={App} />
            <Route exact path="/help" component={Help} />
            <Route exact path="/instructions" component={Instructions} />
            <Route exact path="/help/video" component={HelpVideo} />
            <Route exact path="/accessdenied" component={AccessDenied} />
            <Route exact path="/locked" component={Locked} />
            <Route exact path="/duplicate-session" component={DuplicateSession} />
            <Route exact path="/error" component={ErrorView} />
            <Route exact path="/token" component={TokenRefresh} />
            <Route exact path="/" component={Login} />
            <Route component={NotFound} />
          </Switch>
          <Title />
        </Router>
      </>
    );
  }
}

Main.propTypes = {
  dispatch: PropTypes.func,
  isLoading: PropTypes.bool,
};

Main.defaultProps = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  dispatch: () => { },
};

/**
 *
 * @param {import('types/state').RootState} state
 */
const mapStateToProps = (state) => ({
  isLoading: rootSelectors.api.isLoading(state),
  hasFetchResponses: rootSelectors.api.hasFetchResponses(state),
});

export default connect(mapStateToProps)(Main);
